<script setup>
import {ref} from 'vue'
import LayoutHeader from './components/LayoutHeader.vue';
import LayoutFooter from './components/LayoutFooter.vue';
import LayoutFixed from './components/LayoutFixed.vue';
import phoneHeader from './components/phoneHeader.vue';
import { useRouter } from 'vue-router';
const router = useRouter()
const currentRoute = ref(router.currentRoute.value.path);
// 监听路由变化
watch(
    () => router.currentRoute.value.path,
    (newPath) => {
        currentRoute.value = newPath;
    }
);

// 触发获取导航列表的action
// import { useCategoryStore } from '@/stores/categoryStore';
import { onMounted } from 'vue'

// const categoryStore = useCategoryStore()
const isMobile=ref(false);
onMounted(() => {
    // categoryStore.getCategory()
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    
})
</script>
<template>
    <div class="miandiv">
        <LayoutFixed class="pc" v-if="isMobile==false"/>
        <LayoutHeader class="pc" v-if="isMobile==false"/>
        <phoneHeader class="phone" v-if="isMobile==true"/>
        <!-- 添加key 破坏复用机制 强制销毁重建-->
        <RouterView  class="content"/>
        <!-- <RouterView /> -->
        <LayoutFooter class="pc Footer" v-if="isMobile==false"/>
    </div>
</template>
<style scoped lang="scss">
.phone {
    display: none;
}
.content{
    // height: calc(100vh - 428px);

}
.miandiv {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    // overflow: scroll;

    .Footer {
        margin-top: auto;
    }
}

/* 响应式设计 */
@media (max-width: 768px) {

.miandiv {
    height: 100%;
    display: flex;
    flex-direction: column;
    background-color: #f7f7f7;
    // overflow: scroll;

    .Footer {
        margin-top: auto;
    }
}
    .pc {
        display: none;
    }

    .phone {
        display: block;
    }
}
</style>
